import React from 'react'
import { Divider } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import type { OnRemoveRecentSearch, OnSubmit, SelectableRow } from '../types'
import { Inspiration } from '../Inspirations/Inspiration'
import { RecentSearch } from '../RecentSearches/RecentSearch'
import { Reminder } from '../Reminders/Reminder'
import { NavigationalSuggestion } from '../NavigationalSuggestions/Navigational'
import { Suggestion } from '../Suggestions/Suggestion'
import { SearchFallback } from '../Suggestions/SearchFallback'
import { ListItem } from './ListItem'

const StyledDivider = styled(Divider)`
  ${s({
    marginY: 0,
    bgcolor: 'colorBackgroundDeactivated',
    borderRadius: 0,
  })}
`

const renderItem = ({
  row,
  inputValue,
  onRemoveRecentSearch,
}: {
  row: SelectableRow
  inputValue: string
  onRemoveRecentSearch: OnRemoveRecentSearch
}) => {
  switch (row.kind) {
    case 'recent':
      return <RecentSearch row={row} onRemoveItem={onRemoveRecentSearch} />
    case 'reminder':
      return <Reminder row={row} />
    case 'inspiration':
      return <Inspiration row={row} />
    case 'navigational':
      return <NavigationalSuggestion row={row} />
    case 'suggestion':
      return <Suggestion row={row} value={inputValue} />
    case 'search-fallback':
      return <SearchFallback row={row} />
    /* istanbul ignore next */
    default:
      return null
  }
}

export const mapItems = ({
  items,
  firstListItemlRef,
  groupIndex,
  onSubmit,
  inputValue,
  onRemoveRecentSearch,
}: {
  items: SelectableRow[]
  firstListItemlRef: React.RefObject<HTMLDivElement | null>
  groupIndex: number
  onSubmit: OnSubmit
  inputValue: string
  onRemoveRecentSearch: OnRemoveRecentSearch
}) => {
  return items.map((row, index) => {
    const isFirstListItem = groupIndex === 0 && index === 0
    return (
      <>
        {row.kind === 'search-fallback' && <StyledDivider />}
        <ListItem
          row={row}
          key={`${row.index}-${row.item.value}`}
          onSubmit={onSubmit}
          firstListItemlRef={isFirstListItem ? firstListItemlRef : undefined}
        >
          {renderItem({ row, inputValue, onRemoveRecentSearch })}
        </ListItem>
      </>
    )
  })
}
